import {
  Button,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import TableCellComponent from "components/table/TableCellComponent";
import TableRowComponent from "components/table/TableRowComponent";
import { HEADER_WHEEL_TABLE } from "constants/data";
import Typography from "@mui/material/Typography";
import { MstItemDetailWheel } from "../types";

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(even)": {
    backgroundColor: "var(--offwhite-300)",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--white)",
  },
}));

interface WheelTableProps {
  wheels: MstItemDetailWheel[];
  openModal: (wheel: MstItemDetailWheel) => void;
}

/**
 * WheelTable component renders a table with wheel details.
 *
 * @param {WheelTableProps} props - The properties for the component.
 * @param {Wheel[]} props.wheels - The list of wheels to display.
 * @returns {JSX.Element} The rendered table component.
 */
export default function WheelTable({ wheels, openModal }: WheelTableProps) {
  return (
    <TableContainer
      component={Table}
      sx={{
        minWidth: 1655,
        width: "100%",
        boxShadow: "none",
      }}
    >
      <TableHead>
        <TableRowComponent data={HEADER_WHEEL_TABLE} type="header" />
      </TableHead>
      <TableBody>
        {wheels.map((wheel, index) => (
          <StyledTableRow
            key={Math.floor(Math.random() * 100) + wheel.item_cd}
            className={index % 2 === 0 ? "even" : "odd"}
          >
            <TableCellComponent>{wheel.item_cd}</TableCellComponent>
            <TableCellComponent sx={{ textAlign: "left" }}>{wheel.maker_name}</TableCellComponent>
            <TableCellComponent sx={{ textAlign: "center" }}>{wheel.brand_cd}</TableCellComponent>
            <TableCellComponent sx={{ textAlign: "left" }}>{wheel.brand_name}</TableCellComponent>
            <TableCellComponent sx={{ textAlign: "center", py: 1 }}>
              {wheel.wheel_size} <br />
              <Typography sx={{ fontSize: { xs: "12px", md: "14px" } }}>
                {wheel.wheel_color_name}
              </Typography>
            </TableCellComponent>
            <TableCellComponent sx={{ textAlign: "center", py: 1 }}>
              <Button
                variant="outlined"
                onClick={() => {
                  openModal(wheel);
                }}
                sx={{
                  border: "1px solid var(--gray-250)",
                  backgroundColor: "var(--white)",
                  color: "var(--black)",
                  fontSize: { xs: 16, md: 18, lg: 20 },
                  borderRadius: "4px",
                  width: { xs: "100%", xl: "83%" },
                  height: "40px",
                  whiteSpace: "pre",
                }}
              >
                詳細
              </Button>
            </TableCellComponent>
          </StyledTableRow>
        ))}
      </TableBody>
    </TableContainer>
  );
}
